import { ExternalLink } from "@/components/podkit/typography/Link";
import { Text } from "@/components/podkit/typography/Text";
import { type PlainRunner } from "@/queries/runner-queries";
import { AWSRunnerAdditionalFieldsKeys } from "@/components/runners/details/runner-configuration-keys";
import { type FC, type ReactNode } from "react";
import { RunnerPhaseTag } from "@/components/runners/RunnerPhaseTag";

export const CloudFormationStackDetails: FC<{ runner: PlainRunner }> = ({ runner }) => {
    const dict = Object.fromEntries(runner.status?.additionalInfo.map((info) => [info.key, info.value]) || []);

    const accountID = dict[AWSRunnerAdditionalFieldsKeys.AWSAccountID] || "";
    const url = dict[AWSRunnerAdditionalFieldsKeys.StackURL] || "";
    const name = dict[AWSRunnerAdditionalFieldsKeys.StackName] || "";
    const region = dict[AWSRunnerAdditionalFieldsKeys.Region] || "";
    const logURL = dict[AWSRunnerAdditionalFieldsKeys.LogURL] || "";

    return (
        <div className="flex flex-col gap-2 overflow-x-hidden">
            {runner && (
                <div className="flex flex-col gap-1 md:flex-row md:gap-2 items-center">
                    <Text className="min-w-max text-base">Status: </Text>
                    <div className="shrink truncate">
                        <RunnerPhaseTag runner={runner} />
                    </div>
                </div>
            )}
            {accountID && <Info label="AWS Account ID">{accountID}</Info>}
            {name && <Info label="Stack name">{name}</Info>}
            {url && (
                <Info label="Stack URL">
                    <ExternalLink href={url} className="block truncate text-content-orange">
                        {url}
                    </ExternalLink>
                </Info>
            )}
            <Info label="Runner name">{runner.name}</Info>
            {region && <Info label="Runner region">{region}</Info>}
            {logURL && (
                <Info label="Runner logs">
                    <ExternalLink href={logURL} className="block truncate text-content-orange">
                        {logURL}
                    </ExternalLink>
                </Info>
            )}
        </div>
    );
};

const Info: FC<{ label: string; children: ReactNode }> = ({ label, children }) => (
    <div className="flex flex-col gap-1 md:flex-row md:gap-2 items-center">
        <Text className="min-w-max text-base">{label}: </Text>
        <Text className="shrink truncate text-base font-bold">{children}</Text>
    </div>
);
